import { useNavigate } from "react-router-dom";
import "./404.css";

function NotFound() {
    const navigate = useNavigate();

    function takeMeHome() {
        navigate('/', { replace: true });
    }

    return (
        <div className="not-found">
            <h1>404</h1>
            <p>We think you took a wrong path. Don't worry, we can take you back home.</p>
            <button onClick={takeMeHome}>Take Me Home</button>
        </div>
    );
}

export default NotFound;